import API from "../../../../../global/api";
import jsPDF from "jspdf";
// import moment from "moment";
import _ from "lodash";
import { PDFHeader } from "../../../../../global/globalFunctions";


export const requestAgingPDF = () => {
    return {
        type: "REQUEST_ADD_AGING",
    };
};
export const successAgingPDF = (data) => {
    return {
        type: "SUCCESS_ADD_AGING",
        payload: data,
    };
};
export const errorAgingPDF = () => {
    return {
        type: "ERROR_ADD_AGING",
    };
};
export const AgingReportPDFApi = (payload) => {
    return (dispatch) => {
        dispatch(requestAgingPDF());
        API.post(`/reports/aging_report`, payload).then((res) => {
            let getData = res.data;

            const unit = "pt";
            const size = "A4";
            const orientation = "l";
            const doc = new jsPDF(orientation, unit, size);
            PDFHeader(doc, "Aging Report");

            const TitleOfAccount = `Account Name: ${payload.levelFourName}`;
            const grandTotal = `Grand Total: ${_.sumBy(getData.ledger_history)}`;
            const headers = [[
                "Last Paid Amount",
                "Last Paid Date",
                "Balance",
                `    1-15\n${getData.duration[0].endDate}\n${getData.duration[0].startedDate}`,
                `    16-30\n${getData.duration[1].endDate}\n${getData.duration[1].startedDate}`,
                `    31-45\n${getData.duration[2].endDate}\n${getData.duration[2].startedDate}`,
                `    46-60\n${getData.duration[3].endDate}\n${getData.duration[3].startedDate}`,
                `    61-75\n${getData.duration[4].endDate}\n${getData.duration[4].startedDate}`,
                `    76-90\n${getData.duration[5].endDate}\n${getData.duration[5].startedDate}`,
                `   90-105\n${getData.duration[6].endDate}\n${getData.duration[6].startedDate}`,
                `   105-120\n${getData.duration[7].endDate}\n${getData.duration[7].startedDate}`,
            ]];
            const data = [[
                getData.lastDebit,
                getData.lastDebitDate,
                "Balance",
                `${getData.ledger_history[0]}`,
                `${getData.ledger_history[1]}`,
                `${getData.ledger_history[2]}`,
                `${getData.ledger_history[3]}`,
                `${getData.ledger_history[4]}`,
                `${getData.ledger_history[5]}`,
                `${getData.ledger_history[6]}`,
                `${getData.ledger_history[7]}`,
            ]];
            let content = {
                startY: 150,
                startX: 0,
                head: headers,
                body: data,
            };
            doc.autoTable(content);

            doc.setFontSize(12);
            doc.setFont("Times New Roman", "bold");
            doc.text(TitleOfAccount, 50, 130);
            doc.text(grandTotal, 50, doc.lastAutoTable.finalY + 20);


            doc.setProperties({ title: `Aging Report` });
            var blob = doc.output("blob");
            window.open(URL.createObjectURL(blob));

            dispatch(successAgingPDF(res.data));
        }).catch((error) => {
            dispatch(errorAgingPDF());
        });
    };
};
